import io from 'socket.io-client';
import feathers from '@feathersjs/client';

const socket = io(process.env.REACT_APP_FEATHERS_URL);
const app = feathers();

const sec = 1000;
const min = sec * 60;
const quarter = min * 15;
const half = quarter * 2;
const hour = half * 2;

const timeout = hour;

app.configure(feathers.socketio(socket, { timeout }));

export default app;
